import Transform from "@ember-data/serializer/transform";
import type Store from "@ember-data/store";
import { service } from "@ember/service";
import type { BioExamResultArgs } from "parog-web/models/bio-exam-result";
import BioExamResult from "parog-web/models/bio-exam-result";

export default class BioExamResultTransform extends Transform {
  @service declare store: Store;

  deserialize(serialized: unknown): Array<BioExamResult> | undefined {
    if (serialized instanceof Array) {
      return serialized.map(
        r => new BioExamResult(Object.assign({ store: this.store }, r))
      );
    }
    return undefined;
  }

  serialize(deserialized: unknown): BioExamResultArgs[] | undefined {
    if (deserialized instanceof Array) {
      return deserialized.map((r: BioExamResult) => r.serialize());
    }
    return undefined;
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    "bio-exam-result": BioExamResultTransform;
  }
}
